export const getWindowSize = (): {
  innerWidth: number;
  innerHeight: number;
} => {
  const { innerWidth, innerHeight } = window;

  return { innerWidth, innerHeight };
};
